import moment from 'moment';
import { DateFormats } from 'constants/common';
import { DealActivityStatus } from '@trnsact/trnsact-shared-types';

import { QuickFilterConfig } from './types';
import { ListingFiltersValues } from './ui/table/types';

// Built on each call so "today" is never frozen at module load (e.g. a tab left open past midnight).
export const getInitialFilters = (): ListingFiltersValues => {
  const today = moment();

  return {
    filters: {
      search: '',
      type: [],
      status: [],
      priority: [],
      dateRange: {
        from: today.clone().startOf('day').format(DateFormats.ISO),
        to: today.clone().endOf('day').format(DateFormats.ISO),
      },
    },
  };
};

export const getQuickFiltersConfig = (): QuickFilterConfig[] => {
  const today = moment();

  return [
    {
      label: 'Overdue',
      tooltip: 'Due date before today',
      value: {
        status: [],
        dateRange: {
          from: '',
          to: today.clone().subtract(1, 'day').endOf('day').format(DateFormats.ISO),
        },
      },
    },
    {
      label: 'Today',
      value: {
        status: [],
        dateRange: {
          from: today.clone().startOf('day').format(DateFormats.ISO),
          to: today.clone().endOf('day').format(DateFormats.ISO),
        },
      },
    },
    {
      label: 'Tomorrow',
      value: {
        status: [],
        dateRange: {
          from: today.clone().add(1, 'day').startOf('day').format(DateFormats.ISO),
          to: today.clone().add(1, 'day').endOf('day').format(DateFormats.ISO),
        },
      },
    },
    {
      label: 'Next 30 Days',
      value: {
        status: [],
        dateRange: {
          from: today.clone().startOf('day').format(DateFormats.ISO),
          to: today.clone().add(30, 'days').endOf('day').format(DateFormats.ISO),
        },
      },
    },
    {
      label: 'Complete',
      value: {
        dateRange: null,
        status: [DealActivityStatus.Closed],
      },
    },
  ];
};

export const CURRENT_USER_DEFAULT_COLOR = '#eae1e1';

/**
 * Day/Week keep logged activities (calls, notes, emails) in the all-day band, capped at this many rows
 * with a "+N more" popover for the rest. In the time grid they overlap into unreadable slivers: an
 * activity has no duration, and many share one instant (e.g. everything logged for a due date).
 */
export const TIME_GRID_ALL_DAY_MAX_ROWS = 3;
